interface CustomerIoFormData {
  email: string;
}

export function useCustomerIo() {
  const submitToCustomerIo = async (data: CustomerIoFormData): Promise<any> => {
    console.log('[Waitlist] Submitting email:', data.email);
    try {
      // Use VITE_WAITLIST_API_URL for production (set in Netlify/Render)
      const response = await fetch(`${import.meta.env.VITE_WAITLIST_API_URL}/waitlist/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: data.email })
      });
      console.log('[Waitlist] Received response:', response);
      const json = await response.json();
      console.log('[Waitlist] Parsed JSON:', json);
      if (!response.ok || !json.success) {
        console.error('[Waitlist] Error from server:', json.error || 'Failed to submit form');
        throw new Error(json.error || 'Failed to submit form');
      }
      return json;
    } catch (err) {
      console.error('[Waitlist] Submission failed:', err);
      throw err;
    }
  };


  return { submitToCustomerIo };
}
